import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/r/$restaurantId/s/payment-settings')({
  component: Component,
});

function Component() {
  return <div>onlinePaymentTypes + cash drawer settings</div>;
}
